<template>
  <div class="headline">
    <img src="../assets/the_hindu_logo.png" alt="logo">
    <div v-for="(data, index) in headlinesData" :key="index" class="headline_data">
        <img :src="data.nurl_to_image" alt="" class="news_image">
        <h3>{{data.ntitle}}</h3>
        <span>{{data.ncontent}}</span>
        <span>{{data.nauthor}}</span>
        <span>{{data.npublished_at}}</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Headlines',
  data() {
    return {
      headlinesData: {}
    }
  },
  created: function() {
    // axios.get('http://localhost:3001/data')
    // .then((res)=>{
    //   console.log(res);
    //   this.headlinesData = res.data
    // }).catch((err)=>{
    //   console.log(err);
    // })
    axios.get('http://localhost:3001/data')
    .then((res) => {
      console.log(res);
      this.headlinesData = [
      {
        "sid": "msnbc",
        "created_at": "0001-01-01T00:00:00Z",
        "title_hash": "c50fb45158b9c4d8bcd55d4f6f7f6863",
        "nauthor": "MSNBC",
        "ncontent": "Two stories obliterated everything this weekend. (Well, except if you live in Illinois, or youre a snowbird from Schaumburg.) The two: Trey Lance over Mac Jones to the Niners with the third pick, and… [+64637 chars]",
        "ndesc": "Two stories obliterated everything this weekend. (Well, except if you live in Illinois, or you’re a snowbird from Schaumburg.) The two: Trey Lance over Mac Jones to the Niners with the third pick, and the pre-draft news bomb from Adam Schefter that reigning M…",
        "npublished_at": "2021-05-03T12:00:00Z",
        "ntitle": "Two stories obliterated everything this weekend. (Well, except if you live in Illinois, or you’re a snowbird from Schaumburg.) The two: Trey Lance over Mac Jones to the Niners with the third pick, and the pre-draft news bomb from Adam Schefter that reigning M…",
        "nurl": "https://profootballtalk.nbcsports.com/2021/05/03/aaron-rodgers-trade-nfl-draft-fmia-peter-king/?cid=nbcsports?cid=eref:nbcnews:text",
        "nurl_to_image": "https://profootballtalk.nbcsports.com/wp-content/uploads/sites/25/2021/05/draftfour.jpg",
        "scategory": "",
        "sdesc": "",
        "scountry": "",
        "slang": "",
        "sname": "MSNBC",
        "surl": ""
      },
      {
        "sid": "msnbc",
        "created_at": "0001-01-01T00:00:00Z",
        "title_hash": "27fb99621af193c40ab0fd5642164bd3",
        "nauthor": "MSNBC",
        "ncontent": "KENOSHA, Wis. The white police officer who shot Jacob Blake in Wisconsin last summer was suspended for three days this year because his service weapon was stolen just weeks after the shooting that le… [+2755 chars]",
        "ndesc": "Kenosha Police Officer Rusten Sheskey reported on Sept. 15 that his Glock 17 had been stolen apparently from his girlfriend’s car, authorities said.",
        "npublished_at": "2021-05-03T11:30:00Z",
        "ntitle": "Kenosha Police Officer Rusten Sheskey reported on Sept. 15 that his Glock 17 had been stolen apparently from his girlfriend’s car, authorities said.",
        "nurl": "https://www.nbcnews.com/news/us-news/wisconsin-cop-who-shot-jacob-blake-had-service-weapon-stolen-n1266124",
        "nurl_to_image": "https://media1.s-nbcnews.com/j/newscms/2021_18/3469681/210503-rusten-sheskey-al-0652_e57f656b02dd9704f637357c49c7567f.nbcnews-fp-1200-630.jpg",
        "scategory": "",
        "sdesc": "",
        "scountry": "",
        "slang": "",
        "sname": "MSNBC",
        "surl": ""
      },
      {
        "sid": "msnbc",
        "created_at": "0001-01-01T00:00:00Z",
        "title_hash": "45ae5fc756d5644af78fe335f1b25bf6",
        "nauthor": "MSNBC",
        "ncontent": "Los Angeles Lakers forward LeBron James reinjured his right ankle on Sunday night and his status is unclear for Monday night's game against the visiting Denver Nuggets.\r\nJames departed the 121-114 lo… [+992 chars]",
        "ndesc": "LeBron James said he hopes his ankle injury is not serious after being forced out of the game during the LA Lakers' loss to the Toronto Raptors:",
        "npublished_at": "2021-05-03T11:09:00Z",
        "ntitle": "LeBron James said he hopes his ankle injury is not serious after being forced out of the game during the LA Lakers' loss to the Toronto Raptors:",
        "nurl": "https://www.nbcnews.com/news/us-news/lebron-james-reinjures-ankle-uncertain-denver-nuggets-monday-n1266120",
        "nurl_to_image": "https://media3.s-nbcnews.com/j/newscms/2021_08/3453187/210227-lebron-james-al-0945_9e6481072d6f62fc1d89f391ebeacd9b.nbcnews-fp-1200-630.jpg",
        "scategory": "",
        "sdesc": "",
        "scountry": "",
        "slang": "",
        "sname": "MSNBC",
        "surl": ""
      },
      {
        "sid": "msnbc",
        "created_at": "0001-01-01T00:00:00Z",
        "title_hash": "5d3e64468ee65304de511ebbd2997bf4",
        "nauthor": "MSNBC",
        "ncontent": "WASHINGTON Secretary of State Antony Blinken said in an interview that aired on Sunday that China had recently acted \"more aggressively abroad\" and was behaving \"increasingly in adversarial ways.\"\r\nA… [+2828 chars]",
        "ndesc": "Secretary of State Antony Blinken said in an interview that aired on Sunday that China had recently acted \"more aggressively abroad.\"",
        "npublished_at": "2021-05-03T11:06:18Z",
        "ntitle": "Secretary of State Antony Blinken said in an interview that aired on Sunday that China had recently acted \"more aggressively abroad.\"",
        "nurl": "https://www.nbcnews.com/news/world/china-acting-more-aggressively-abroad-blinken-says-n1266121",
        "nurl_to_image": "https://media2.s-nbcnews.com/j/newscms/2021_18/3469682/210503-antony-blinken-al-0654_11c4664e24a230f927606d0660ea782e.nbcnews-fp-1200-630.jpg",
        "scategory": "",
        "sdesc": "",
        "scountry": "",
        "slang": "",
        "sname": "MSNBC",
        "surl": ""
      },
      {
        "sid": "msnbc",
        "created_at": "0001-01-01T00:00:00Z",
        "title_hash": "6f8cea955374d96738f1fde8d5ed83f4",
        "nauthor": "MSNBC",
        "ncontent": "When Covid-19 hit Detroit, Bishop Edgar Vann had to close up his sanctuary, the venerable Second Ebenezer Church.\r\nHis duty became to use his voice to preach not only the word of God but also the gra… [+9884 chars]",
        "ndesc": "Data show racial disparities in vaccinations are clear throughout the country as it enters its fifth month of the vaccines' rollout.",
        "npublished_at": "2021-05-03T09:30:21Z",
        "ntitle": "Data show racial disparities in vaccinations are clear throughout the country as it enters its fifth month of the vaccines' rollout.",
        "nurl": "https://www.nbcnews.com/politics/white-house/biden-hails-progress-vaccine-equity-some-local-leaders-paint-different-n1264115",
        "nurl_to_image": "https://media4.s-nbcnews.com/j/newscms/2021_17/3468023/210426-biden-100-days-vaccine-equity-2x1-cs_10e9072b7790fd5f8d0d0114e7392109.nbcnews-fp-1200-630.jpg",
        "scategory": "",
        "sdesc": "",
        "scountry": "",
        "slang": "",
        "sname": "MSNBC",
        "surl": ""
      }
    ]
    }).catch((err)=>{
      console.log(err);
    })
  }
}
</script>

<style>
.headline {
  width: inherit;
}
.headline_data {
  margin: 20px;
}
.news_image {
  width: 700px;
}
</style>